// takes care of the logic of the "jungkraut upsell" section (see main-product.liquid)

window.addEventListener("load", () => {
  const jungkrautUpsell = new function() {
    this.clickedUpsell = (e) => {
      if (e.target.tagName === "LABEL") {
        // grab variant id
        const upsellInput = document.getElementById(e.target?.getAttribute("for"));
        const variantId = upsellInput?.dataset?.variantId;
    
        // if somehow not found, don't do anything
        if (!variantId) return;
        
        // update form element "id" value so that when the customer clicks add to cart, the correct product is added
        const addToCartForm = document.getElementById(window.jungkraut_upsell.form_id);
        
        if (!addToCartForm) return;
        
        addToCartForm.querySelector('input[name="id"]').value = variantId;

        // update price
        const priceContainer = document.querySelector(`#price-${window.jungkraut_upsell.section_id}`);
        const newPrices = document.querySelector(`#jk-upsell-price-${variantId}`).cloneNode(true);
        newPrices.style.display = "flex";
        priceContainer.replaceChildren(newPrices);

        // update title
        const titleContainer = document.querySelector("#product-title")
        const newTitle = document.querySelector(`#jk-upsell-title-${variantId}`).cloneNode(true);
        titleContainer.textContent = newTitle.textContent;

        // update description
        const descriptionContainer = document.querySelector("#product-description")
        const newDescription = document.querySelector(`#jk-upsell-description-${variantId}`).cloneNode(true);
        descriptionContainer.innerHTML = newDescription.innerHTML;

        // update images
        const mediaContainer = document.querySelector("#jungkraut-product-media")
        const newMediaContainer = document.querySelector(`#jungkraut-upsell-media-gallery-${variantId}`).cloneNode(true);
        mediaContainer.innerHTML = newMediaContainer.innerHTML

        
        // get first image from flickity carousel
        // main carousel
        //const firstImage = document.querySelector("#flickity-main-slider").querySelector(".carousel-cell");
        //const newImage = document.querySelector(`#jungkraut-upsell-main-image-${variantId}`).querySelector(".carousel-cell").cloneNode(true);

        // thumbnail carousel
        //const firstImageThumbnail = document.querySelector("#flickity-thumbnail-slider").querySelector(".carousel-cell");
        //const newImageThumbnail = document.querySelector(`#jungkraut-upsell-thumbnail-image-${variantId}`).querySelector(".carousel-cell").cloneNode(true);
        
        // main slider
        //flkty.remove(firstImage);
        //flkty.prepend(newImage);
        //flkty.select(0, false, false);

        // thumbnail slider
        //flktyB.remove(firstImageThumbnail);
        //flktyB.prepend(newImageThumbnail);
        
      }
    };
  };
  document.addEventListener("click", jungkrautUpsell.clickedUpsell);
});
